import type { ReactNode } from 'react';
import NextImage from 'next/image';
import NextLink from 'next/link';

import type { PlatformImageProps, PlatformLinkProps } from '@poseidon/components/contexts';
import { PlatformProvider as BasePlatformProvider } from '@poseidon/components/contexts';

import { env } from '~/env';

const NextImageAdapter = ({ src, alt, width, height, fill, className, ...props }: PlatformImageProps) => {
  if (fill) {
    return <NextImage src={src} alt={alt} fill className={className} {...props} />;
  }
  return <NextImage src={src} alt={alt} width={width ?? 0} height={height ?? 0} className={className} {...props} />;
};

const NextLinkAdapter = ({ href, children, ...props }: PlatformLinkProps) => (
  <NextLink href={href} {...props}>
    {children}
  </NextLink>
);

export function NextPlatformProvider({ children }: { children: ReactNode }) {
  return (
    <BasePlatformProvider
      components={{ Image: NextImageAdapter, Link: NextLinkAdapter }}
      imageCdn={{
        cdnBaseUrl: env.NEXT_PUBLIC_IMAGE_RESIZING_SERVER_URL,
        backendUrl: env.NEXT_PUBLIC_BACKEND_URL,
      }}>
      {children}
    </BasePlatformProvider>
  );
}
